import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { CodeListMainItems } from "./code-list-main-items.entity";
import { CodeListStatus } from "@gtpl/shared-models/common-models";

@Entity("code_list_main")
export class CodeListMain {

    @PrimaryGeneratedColumn("increment", { name: 'code_list_main_id' })
        codeListMainId: number;


    @Column('int', {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number; 
    

    

   @Column({
        type: 'int',
        nullable: true,
        name: 'total_cartons'
    })
    totalCartons: number;



   @Column({
        type: 'varchar',
        nullable: true,
        name: 'issued_by'
    })
    issuedBy: string;

   
    @Column({

        type: 'varchar',
        nullable: true,
        name: 'verified_by'
    })
    verifiedBy: string;

   @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;



    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => CodeListMainItems, samples => samples.codeListInfo, { cascade: true })
    codeListItems: CodeListMainItems[];

    @Column({
        type: 'varchar',
        nullable: true,
        name: 'remarks'
    })
    remarks: string;

      @Column({
            type:'enum',
            enum: CodeListStatus, 
            name: 'code_list_status',
            nullable:false,
            default:CodeListStatus.PENDING,
        })
        codeListStatus: CodeListStatus; 
  
}